import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const BRT: Intl.DateTimeFormatOptions = { timeZone: "America/Sao_Paulo" }

export function formatDateBRT(iso: string): string {
  return new Date(iso + "Z").toLocaleDateString("pt-BR", { ...BRT, day: "2-digit", month: "2-digit", year: "numeric" })
}

export function formatDateTimeBRT(iso: string): string {
  return new Date(iso + "Z").toLocaleString("pt-BR", { ...BRT, day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })
}
